// 仮データ（削除予定）
export default {
  name: '東京ビューティー専門学校',
  texts: {},
  supportBanners: [
    {
      link: '',
      image: '/static/img/beauty/top/supportbnr.png',
      text: {
        alt: '就職サポート',
        en: 'SUPPORT',
        jp: '東京ビューティー専門学校の就職サポート'
      }
    }
  ]
}
